//src/app/features/fincenReports/FincenReportForm/index.tsx
import { yupResolver } from '@hookform/resolvers/yup';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { IFincenReport, IFincenReportForm } from 'app/services/fincenReports';
import {
  useGetUserBusinessByIdQuery,
  useGetUserBusinessesQuery,
} from 'app/services/user';
import Spinner from 'Components/Spinner';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAuth } from 'utils/AuthProvider';
import { FormFields, validationSchema } from './FormFields';

export default function FincenReportForm({
  value,
  onChange,
}: {
  value?: Partial<IFincenReportForm>;
  onChange: (v: Partial<IFincenReport>) => Promise<any>;
  isLoading?: boolean;
}) {
  const methods = useForm<IFincenReportForm>({
    defaultValues: value,
    resolver: yupResolver(validationSchema),
  });

  const { user } = useAuth();

  const { handleSubmit, setValue, watch } = methods;
  const type = watch('type');
  const businessId = watch('business_id');

  const { data: businessData } = useGetUserBusinessByIdQuery(businessId!, {
    skip: !businessId,
  });

  useEffect(() => {
    if (type === 'individual' && user) {
      setValue('mailingaddress', user.address || '');
      setValue('mailingcity', user.city || '');
      setValue('state', user.state || '');
      setValue('zip', user.zipcode || '');
    }

    if (
      type === 'business' &&
      businessData &&
      businessId == businessData.business.id
    ) {
      setValue('mailingaddress', businessData.business.address || '');
      setValue('mailingcity', businessData.business.city || '');
      setValue('state', businessData.business.state || '');
      setValue('zip', businessData.business.zipcode || '');
      setValue('businessType', businessData.business.business_type);
    }
  }, [type, user, businessId, businessData]);

  return (
    <ScrollContainer>
      <FormProvider {...methods}>
        <form
          id="fincen-report-form"
          onSubmit={handleSubmit((data) =>
            onChange({
              year: data.year,
              business_id:
                data.type === 'business' ? data.business_id : undefined,
              type: data.business_id ? 'business' : 'individual',
              title: `Fincen Report - ${data.year} - ${
                data.business_id
                  ? 'Business'
                  : `${data.submittedbyfirstname} ${data.submittedbylastname}`
              }`,
              data,
            }),
          )}
        >
          <div className={` p-4 w-2/3 md-max:w-full grid`}>
            <FormFields
              type={type}
              updateValue={setValue}
              fincenReport={value}
            />
          </div>
        </form>
      </FormProvider>
    </ScrollContainer>
  );
}
